import { React, useState, useEffect } from "react";
import SearchCriteria from "../../Utils/SearchCriteria";
import { useDispatch, useSelector } from "react-redux";
import { Container, Alert } from "reactstrap";
// import { connect } from "react-redux";
import errors from "../../Constants/errors.json";
// import ViewUserDetails from '../View/ViewForm';
import Mapping from "../../Utils/Mapping";
import {
  getUserDetails,
  errorWhileFetch,
  setUserList,
} from "../../../actions/users";
import { Loading } from "../../../loader/Loading";
import ResetForm from "./ResetForm";
import DocumentTitle from "react-document-title";
import InfiniteScrollTable from "../../Common/InfiniteScrollCognito";
import { enAPI } from "../../../config";

function ResetSearch(props) {
  const dispatch = useDispatch();
  const { usersList, userDetails, success, searchAttributes, lastKey } =
    useSelector((state) => state?.users);
  const isLoading = useSelector((state) => state?.fetch?.isLoading);
  const error = useSelector((state) => state?.error?.error_obj);
  const app = useSelector((state) => state?.pool?.userPool);
  const authToken = useSelector((state) => state?.auth?.token);

  // const clearErrorFn = () => {
  //   dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  // };
  // const clearUsersListFn = () => {
  //   dispatch({ type: "USERS_LIST", data: { usersList: undefined } });
  //   dispatch({ type: "RESET_PASSWORD", data: { success: undefined } });
  // };
  const getUserDetailsFn = (username) => dispatch(getUserDetails(username));
  const errorWhileFetchFn = (err) => dispatch(errorWhileFetch(err));
  const setUserListFn = (...props) => dispatch(setUserList(...props));
  const clearResetMessageFn = () => {
    dispatch({ type: "RESET_PASSWORD", data: { success: undefined } });
  };

  const [currState, setCurrState] = useState({
    modal: false,
    property: undefined,
    resetUserList: [],
  });

  const PropertySet = (value) => {
    clearResetMessageFn();
    setCurrState({
      ...currState,
      property: value,
    });
    toggle();
  };

  const toggle = () => {
    setCurrState({
      ...currState,
      modal: !currState?.modal,
    });
  };

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch({ type: "USERS_LIST", data: { usersList: undefined } });
    dispatch({ type: "RESET_PASSWORD", data: { success: undefined } });

    return () => {
      dispatch({ type: "USERS_LIST", data: { usersList: undefined } });
      dispatch({ type: "RESET_PASSWORD", data: { success: undefined } });
      dispatch({ type: "RESET_PASSWORD", data: { success: undefined } });
    };
  }, [dispatch]);

  /* static getDerivedStateFromProps = (props, state) => {
  		const { usersList } = props;
  		let filterB2BUserList =
  			usersList && usersList.filter(list => String(list['custom:usertype']).toLowerCase() !== 'internal');
  		return { resetUserList: filterB2BUserList };
  	}; */

  const cols = [
    {
      label: "UserName",
      dataKey: "email",
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              backgroundColor: "none",
              borderColor: "none",
              color: "blue",
              cursor: "pointer",
            }}
            onClick={(e) => {
              PropertySet(rowData);
              getUserDetailsFn(rowData.Username);
            }}
          >
            {rowData.email}
          </div>
        );
      },
    },
    {
      label: "First Name",
      dataKey: "given_name",
      width: "100",
    },
    {
      label: "Last Name",
      dataKey: "family_name",
      width: "100",
    },
    {
      label: "Company",
      dataKey: "custom:company",
      width: "250",
    },
  ];

  return (
    <>
      <DocumentTitle title={`Doorkeeper | Reset Password`}></DocumentTitle>
      <Container style={{ padding: "0% 2%" }}>
        <h5 style={{ marginLeft: "42%" }}>Reset Password</h5>
        {success && !isLoading && (
          <Alert color="success" style={{ marginBottom: "0px" }}>
            <h6>Password Reset Successfully!</h6>
          </Alert>
        )}
        {currState?.modal && !error && userDetails && (
          <ResetForm
            modal={currState?.modal}
            toggle={toggle}
            userDetails={userDetails}
          />
        )}
        <SearchCriteria action="reset" />
        {isLoading && !error && <Loading />}
        {usersList && usersList.length > 0 && searchAttributes && !error && (
          /*<SearchResults
								columns={columns}
								data={this.state.resetUserList}
								tableHeight={'50vh'}
							/>*/
          <InfiniteScrollTable
            columnData={cols}
            data={usersList}
            gridClassName={"gridClass"}
            rowHeight={45}
            page={"viewSearch"}
            url={`${enAPI}${app}/searchusers`}
            lastKey={lastKey}
            authToken={authToken}
            searchAttributes={searchAttributes}
            errorWhileFetch={errorWhileFetchFn}
            fetchComplete={props.fetchComplete}
            deleted_status={props.deleted_status}
            setUserList={setUserListFn}
          />
        )}
        {!error && usersList && usersList.length === 0 && !isLoading && (
          <Alert color="info" style={{ textAlign: "center" }}>
            <h6>No records found.</h6>
          </Alert>
        )}
        {error && (
          <Alert color="danger" style={{ textAlign: "center" }}>
            <h5>
              <Mapping dictionary={errors} word={error.errorPath} />
            </h5>
          </Alert>
        )}
      </Container>
    </>
  );
}

export default ResetSearch;
